import { classNames } from "primereact/utils";
import { ReactElement } from "react";
const stepperStyle = "w-3rem h-3rem border-circle font-bold flex align-items-center justify-content-center";

type PropTypes = {
    step: number
};
function RequestStepper(props: PropTypes): ReactElement {

    const {
        step
    } = props;

    return (
        <div className="flex align-items-center">
            <div className={classNames(stepperStyle, {
                "bg-primary text-white": step >= 1,
            })}>
                1
            </div>
            <div className={classNames("w-5rem border-top-3", {
                "border-primary bg-primary": step > 1,
                "border-gray-200 bg-gray-20": step == 1,
            })} />

            <div className={classNames(stepperStyle, {
                "bg-primary text-white": step >= 2,
                "bg-gray-200 text-600": step < 2
            })}>
                2
            </div>            
            <div className={classNames("w-5rem border-top-3", {
                "border-primary bg-primary": step >= 3,
                "border-gray-200 bg-gray-20": step < 3,
            })} />

            <div className={classNames(stepperStyle, {
                "bg-primary text-white": step >= 3,
                "bg-gray-200 text-600": step < 3
            })}>
               3
            </div>            
            <div className={classNames("w-5rem border-top-3", {
                "border-primary bg-primary": step === 4,
                "border-gray-200 bg-gray-20": step < 4,
            })} />

            <div className={classNames(stepperStyle, {
                "bg-primary text-white": step >= 4,
                "bg-gray-200 text-600": step < 4
            })}>
               4
            </div>
        </div>
    )
}

export default RequestStepper;